globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { memo, useMemo } from 'react';
import Image from 'next/image';
import { Badge as FlowBiteBadge } from 'flowbite-react';
import { BuildingOfficeIcon, CheckBadgeIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { NOfficeBuildingIcon, NoLocationMarkerIcon, PrivateModeProtectionIcon, SkeletonPhotoBorderedIcon, customImageLoader, formatDate } from '@restworld/utils-common';
import { Title, Card, LinkBase, Paragraph, ParagraphLabelWithIcon } from '../..';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LinkWrapper = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      redirectUrl = _ref.redirectUrl,
      onLinkClick = _ref.onLinkClick;
  return redirectUrl || onLinkClick ? /*#__PURE__*/_jsx(LinkBase, {
    twStyle: {
      "display": "flex",
      "width": "100%",
      "flex": "1 1 0%",
      "flexDirection": "column",
      "justifyContent": "space-between",
      "gap": "1rem"
    },
    onLinkClick: onLinkClick,
    link: redirectUrl,
    "data-cy": "redirect-link",
    children: children
  }) : /*#__PURE__*/_jsx(CardWrapper, {
    children: children
  });
});
export function JobPositionCard(_ref2) {
  var showRestaurantDetails = _ref2.showRestaurantDetails,
      restaurantName = _ref2.restaurantName,
      city = _ref2.city,
      jobTitle = _ref2.jobTitle,
      occupation = _ref2.occupation,
      salaryMin = _ref2.salaryMin,
      salaryMax = _ref2.salaryMax,
      jobType = _ref2.jobType,
      publishedAt = _ref2.publishedAt,
      baseRedirectUrl = _ref2.redirectUrl,
      restaurantLogo = _ref2.restaurantLogo,
      isActive = _ref2.isActive,
      isLoading = _ref2.isLoading,
      ambassadorCode = _ref2.ambassadorCode,
      id = _ref2.id,
      _ref2$cardVariant = _ref2.cardVariant,
      cardVariant = _ref2$cardVariant === void 0 ? 'job-offer' : _ref2$cardVariant,
      onLinkClick = _ref2.onLinkClick,
      actionButtonsEl = _ref2.actionButtonsEl,
      twStyle = _ref2.twStyle,
      hasAlreadyApplied = _ref2.hasAlreadyApplied,
      restaurantAddress = _ref2.restaurantAddress,
      testId = _ref2.testId,
      isJobPositionOutsideItaly = _ref2.isJobPositionOutsideItaly;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var redirectUrl = useMemo(function () {
    return ambassadorCode ? "".concat(baseRedirectUrl, "?utm_source=referral&utm_medium=ambassador&utm_campaign=worker_acquisition&ref_code=").concat(ambassadorCode) : baseRedirectUrl;
  }, [baseRedirectUrl, ambassadorCode]);

  var _useMemo = useMemo(function () {
    return {
      buildingOfficeBlackIconEl: /*#__PURE__*/_jsx(BuildingOfficeIcon, {
        className: "h-5 w-5 text-gray-900"
      }),
      nOfficeBuildingIconEl: /*#__PURE__*/_jsx(NOfficeBuildingIcon, {}),
      mapPinIconEl: /*#__PURE__*/_jsx(MapPinIcon, {
        className: "h-5 text-black"
      }),
      noLocationMarkerIconEl: /*#__PURE__*/_jsx(NoLocationMarkerIcon, {}),
      privateModeProtectionIconEl: /*#__PURE__*/_jsx(PrivateModeProtectionIcon, {}),
      mapPinIconPurple: /*#__PURE__*/_jsx(MapPinIcon, {
        className: "h-5 w-5 text-primary-800"
      }),
      privateModeProtectionPurpleIcon: /*#__PURE__*/_jsx(PrivateModeProtectionIcon, {
        stroke: "#693EB5"
      })
    };
  }, []),
      buildingOfficeBlackIconEl = _useMemo.buildingOfficeBlackIconEl,
      nOfficeBuildingIconEl = _useMemo.nOfficeBuildingIconEl,
      mapPinIconEl = _useMemo.mapPinIconEl,
      noLocationMarkerIconEl = _useMemo.noLocationMarkerIconEl,
      privateModeProtectionIconEl = _useMemo.privateModeProtectionIconEl,
      mapPinIconPurple = _useMemo.mapPinIconPurple,
      privateModeProtectionPurpleIcon = _useMemo.privateModeProtectionPurpleIcon;

  return isLoading ? /*#__PURE__*/_jsx(JobPositionCardLoader, {
    cardVariant: cardVariant
  }) : /*#__PURE__*/_jsx(Card, {
    testId: testId,
    variant: cardVariant !== 'restaurant' ? 'primary50' : 'gray100',
    isActive: isActive,
    twStyle: cardVariant !== 'restaurant' ? {
      "borderWidth": "1px",
      "borderColor": "transparent",
      "--tw-shadow": "0 0 #0000",
      "--tw-shadow-colored": "0 0 #0000",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
      "transitionProperty": "all",
      "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
      "transitionDuration": "300ms",
      ":hover": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(239 237 255 / var(--tw-bg-opacity))"
      },
      ":focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(239 237 255 / var(--tw-bg-opacity))"
      }
    } : {
      "minHeight": "8rem",
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))",
      "--tw-shadow": "0 0 #0000",
      "--tw-shadow-colored": "0 0 #0000",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
      "transitionProperty": "all",
      "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
      "transitionDuration": "300ms",
      ":hover": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 114 128 / var(--tw-border-opacity))"
      },
      ":focus": {
        "--tw-border-opacity": "1",
        "borderColor": "rgb(107 114 128 / var(--tw-border-opacity))"
      }
    },
    children: /*#__PURE__*/_jsxs(Wrapper, {
      cardVariant: cardVariant,
      twStyle: twStyle,
      children: [/*#__PURE__*/_jsxs(LinkWrapper, {
        redirectUrl: redirectUrl,
        onLinkClick: onLinkClick,
        children: [/*#__PURE__*/_jsx(RestaurantHeaderDetails, {
          children: /*#__PURE__*/_jsxs(RestaurantNameLogo, {
            children: [/*#__PURE__*/_jsxs(RestaurantNameLogoTitle, {
              children: [/*#__PURE__*/_jsxs(RestaurantCityName, {
                children: [{
                  'job-offer': showRestaurantDetails ? /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                    label: restaurantName ? restaurantName : t('common:name_hidden'),
                    icon: restaurantName ? buildingOfficeBlackIconEl : nOfficeBuildingIconEl,
                    maxChars: 30
                  }) : undefined,
                  restaurant: /*#__PURE__*/_jsx(Title, {
                    fontWeight: "semibold",
                    textColor: "black",
                    content: restaurantName !== null && restaurantName !== void 0 ? restaurantName : t('common:name_hidden'),
                    standardVariant: "h5",
                    maxChars: 30
                  }),
                  'job-proposal': showRestaurantDetails ? /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                    label: restaurantName ? restaurantName : t('common:name_hidden'),
                    icon: restaurantName ? buildingOfficeBlackIconEl : nOfficeBuildingIconEl,
                    maxChars: 30
                  }) : undefined
                }[cardVariant], showRestaurantDetails && cardVariant !== 'restaurant' ? /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                  label: city || t('common:hidden_location'),
                  icon: city ? isJobPositionOutsideItaly ? '🌍' : mapPinIconEl : noLocationMarkerIconEl
                }) : undefined, !showRestaurantDetails && cardVariant !== 'restaurant' && /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                  label: t('common:hidden_location'),
                  icon: privateModeProtectionIconEl
                })]
              }), cardVariant !== 'restaurant' && /*#__PURE__*/_jsx(Title, {
                content: jobTitle,
                standardVariant: "h5",
                textColor: "black",
                fontWeight: "semibold",
                maxChars: 70
              }), restaurantAddress && cardVariant === 'restaurant' && showRestaurantDetails && /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                label: restaurantAddress,
                icon: mapPinIconPurple,
                maxChars: 36
              }), !showRestaurantDetails && cardVariant === 'restaurant' && /*#__PURE__*/_jsx(ParagraphLabelWithIcon, {
                label: t('common:hidden_location'),
                icon: privateModeProtectionPurpleIcon
              })]
            }), restaurantLogo && showRestaurantDetails && /*#__PURE__*/_jsx(ImageLogo, {
              logo: restaurantLogo
            })]
          })
        }), cardVariant !== 'restaurant' ? /*#__PURE__*/_jsxs(OccupationSalaryWrapper, {
          children: [occupation ? /*#__PURE__*/_jsx(Badge, {
            children: occupation
          }) : null, salaryMin && salaryMax ? /*#__PURE__*/_jsxs(Badge, {
            children: ["\u20AC", salaryMin, "-", salaryMax]
          }) : null, jobType ? /*#__PURE__*/_jsx(Badge, {
            children: jobType
          }) : null]
        }) : null, /*#__PURE__*/_jsxs(PublishLocationWrapper, {
          children: [/*#__PURE__*/_jsxs(Paragraph, {
            standardVariant: "body-sm",
            color: "gray-600",
            children: [cardVariant === 'restaurant' ? t('common:registered_by') : t('common:published_by'), ' ', publishedAt ? formatDate(publishedAt) : '-']
          }), hasAlreadyApplied && cardVariant !== 'restaurant' && /*#__PURE__*/_jsx(HasAlreadyAppliedBadge, {
            children: /*#__PURE__*/_jsxs(HasAppliedContainer, {
              children: [/*#__PURE__*/_jsx(_StyledCheckBadgeIcon, {}), /*#__PURE__*/_jsxs(Paragraph, {
                standardVariant: "body-sm",
                color: "primary-900",
                children: [t('common:you_applied'), "*"]
              })]
            })
          })]
        })]
      }), actionButtonsEl ? /*#__PURE__*/_jsx(Footer, {
        children: actionButtonsEl ? actionButtonsEl : null
      }) : null]
    })
  });
}
export default JobPositionCard;

var CardWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__CardWrapper",
  componentId: "sc-1yeaqnw-0"
})({
  "display": "flex",
  "width": "100%",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "gap": "1rem"
});

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__Wrapper",
  componentId: "sc-1yeaqnw-1"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "minHeight": "11rem",
  "width": "100%",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "gap": "1rem",
  "@media (min-width: 1024px)": {
    "minHeight": "12rem"
  },
  "@media (min-width: 1280px)": {
    "minHeight": "12.5rem"
  },
  "@media (min-width: 1536px)": {
    "minHeight": "11rem"
  }
}, function (_ref3) {
  var cardVariant = _ref3.cardVariant;
  return cardVariant === 'restaurant' ? {
    "minHeight": "8rem !important"
  } : {};
}, function (_ref4) {
  var cardVariant = _ref4.cardVariant;
  return cardVariant === 'job-proposal' ? {
    "minHeight": "17rem !important"
  } : {};
}, function (_ref5) {
  var twStyle = _ref5.twStyle;
  return twStyle && !Array.isArray(twStyle) ? twStyle : {};
}, function (_ref6) {
  var twStyle = _ref6.twStyle;
  return twStyle && Array.isArray(twStyle) ? twStyle : {};
});

var RestaurantHeaderDetails = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__RestaurantHeaderDetails",
  componentId: "sc-1yeaqnw-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var RestaurantNameLogoTitle = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__RestaurantNameLogoTitle",
  componentId: "sc-1yeaqnw-3"
})({
  "display": "flex",
  "width": "100%",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var RestaurantNameLogo = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__RestaurantNameLogo",
  componentId: "sc-1yeaqnw-4"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.75rem"
});

var RestaurantCityName = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__RestaurantCityName",
  componentId: "sc-1yeaqnw-5"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "row",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var OccupationSalaryWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__OccupationSalaryWrapper",
  componentId: "sc-1yeaqnw-6"
})({
  "display": "flex",
  "width": "100%",
  "flexWrap": "wrap",
  "justifyContent": "flex-start",
  "gap": "0.5rem"
});

var Badge = /*#__PURE__*/_styled(FlowBiteBadge).withConfig({
  displayName: "job-position-card__Badge",
  componentId: "sc-1yeaqnw-7"
})(["", ";"], {
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});

var PublishLocationWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__PublishLocationWrapper",
  componentId: "sc-1yeaqnw-8"
})(["", ";div:nth-of-type(1){flex-grow:2;}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});

var HasAppliedContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__HasAppliedContainer",
  componentId: "sc-1yeaqnw-9"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.25rem"
});

var HasAlreadyAppliedBadge = /*#__PURE__*/_styled(FlowBiteBadge).withConfig({
  displayName: "job-position-card__HasAlreadyAppliedBadge",
  componentId: "sc-1yeaqnw-10"
})(["", ";"], {
  "height": "22px",
  "borderRadius": "6px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(231 248 131 / var(--tw-bg-opacity))",
  "paddingTop": "0.125rem",
  "paddingBottom": "0.125rem",
  "paddingLeft": "0.625rem",
  "paddingRight": "0.625rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});

var ImageLogo = function ImageLogo(_ref7) {
  var logo = _ref7.logo;
  return /*#__PURE__*/_jsx(ImageWrapper, {
    children: /*#__PURE__*/_jsx(_StyledImage, {
      loader: customImageLoader,
      width: 48,
      height: 48,
      src: logo,
      alt: "company logo"
    })
  });
};

var ImageWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__ImageWrapper",
  componentId: "sc-1yeaqnw-11"
})({
  "display": "flex",
  "height": "3rem",
  "width": "3rem",
  "minWidth": "48px",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "5.28px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(73 41 131 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingTop": "17.15px",
  "paddingBottom": "17.15px",
  "paddingLeft": "3.96px",
  "paddingRight": "3.96px"
});

var Footer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__Footer",
  componentId: "sc-1yeaqnw-12"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem"
});

var LoaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card__LoaderWrapper",
  componentId: "sc-1yeaqnw-13"
})(["", ";", ""], function (_ref8) {
  var animation = _ref8.animation;
  return animation ? {
    "@keyframes pulse": {
      "50%": {
        "opacity": ".5"
      }
    },
    "animation": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
  } : {};
}, {
  "width": "100%"
});

export var JobPositionCardLoader = function JobPositionCardLoader(_ref9) {
  var _ref9$animation = _ref9.animation,
      animation = _ref9$animation === void 0 ? true : _ref9$animation,
      cardVariant = _ref9.cardVariant;
  return /*#__PURE__*/_jsx(LoaderWrapper, {
    animation: animation,
    children: /*#__PURE__*/_jsx(_StyledDiv, {
      role: "status",
      children: /*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [/*#__PURE__*/_jsxs(_StyledDiv3, {
          children: [/*#__PURE__*/_jsx(_StyledDiv4, {}), /*#__PURE__*/_jsxs(_StyledDiv5, {
            children: [/*#__PURE__*/_jsxs(_StyledDiv6, {
              children: [/*#__PURE__*/_jsx(_StyledDiv7, {}), /*#__PURE__*/_jsx(_StyledDiv8, {})]
            }), /*#__PURE__*/_jsxs(_StyledDiv9, {
              children: [/*#__PURE__*/_jsx(_StyledDiv10, {}), /*#__PURE__*/_jsx(_StyledDiv11, {}), /*#__PURE__*/_jsx(_StyledDiv12, {})]
            })]
          }), /*#__PURE__*/_jsx(_StyledDiv13, {}), cardVariant === 'job-proposal' && /*#__PURE__*/_jsx(_StyledDiv14, {}), cardVariant === 'job-proposal' && /*#__PURE__*/_jsxs(_StyledDiv15, {
            children: [/*#__PURE__*/_jsx(_StyledDiv16, {}), /*#__PURE__*/_jsx(_StyledDiv17, {})]
          })]
        }), /*#__PURE__*/_jsx(_StyledSkeletonPhotoBorderedIcon, {})]
      })
    })
  });
};

var _StyledCheckBadgeIcon = /*#__PURE__*/_styled(CheckBadgeIcon).withConfig({
  displayName: "job-position-card___StyledCheckBadgeIcon",
  componentId: "sc-1yeaqnw-14"
})({
  "height": "14px",
  "width": "14px",
  "--tw-text-opacity": "1",
  "color": "rgb(73 41 131 / var(--tw-text-opacity))"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "job-position-card___StyledImage",
  componentId: "sc-1yeaqnw-15"
})({
  "objectPosition": "center"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv",
  componentId: "sc-1yeaqnw-16"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "borderRadius": "0.938rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv2",
  componentId: "sc-1yeaqnw-17"
})({
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv3",
  componentId: "sc-1yeaqnw-18"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "2rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv4",
  componentId: "sc-1yeaqnw-19"
})({
  "height": "0.375rem",
  "width": "50%",
  "borderRadius": "12px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv5",
  componentId: "sc-1yeaqnw-20"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "2rem",
  "paddingRight": "23px"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv6",
  componentId: "sc-1yeaqnw-21"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "justifyContent": "flex-start",
  "gap": "1rem"
});

var _StyledDiv7 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv7",
  componentId: "sc-1yeaqnw-22"
})({
  "height": "0.375rem",
  "width": "100%",
  "borderRadius": "0.938rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv8 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv8",
  componentId: "sc-1yeaqnw-23"
})({
  "height": "0.375rem",
  "width": "100%",
  "borderRadius": "0.938rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv9 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv9",
  componentId: "sc-1yeaqnw-24"
})({
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
  "gap": "0.5rem"
});

var _StyledDiv10 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv10",
  componentId: "sc-1yeaqnw-25"
})({
  "height": "29px",
  "width": "100%",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv11 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv11",
  componentId: "sc-1yeaqnw-26"
})({
  "height": "29px",
  "width": "100%",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv12 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv12",
  componentId: "sc-1yeaqnw-27"
})({
  "height": "29px",
  "width": "100%",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv13 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv13",
  componentId: "sc-1yeaqnw-28"
})({
  "height": "0.375rem",
  "width": "50%",
  "borderRadius": "12px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv14 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv14",
  componentId: "sc-1yeaqnw-29"
})({
  "height": "0.375rem",
  "width": "50%",
  "borderRadius": "12px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv15 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv15",
  componentId: "sc-1yeaqnw-30"
})({
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "0.5rem",
  "paddingRight": "23px"
});

var _StyledDiv16 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv16",
  componentId: "sc-1yeaqnw-31"
})({
  "height": "49px",
  "width": "100%",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledDiv17 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-card___StyledDiv17",
  componentId: "sc-1yeaqnw-32"
})({
  "height": "49px",
  "width": "100%",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var _StyledSkeletonPhotoBorderedIcon = /*#__PURE__*/_styled(SkeletonPhotoBorderedIcon).withConfig({
  displayName: "job-position-card___StyledSkeletonPhotoBorderedIcon",
  componentId: "sc-1yeaqnw-33"
})({
  "height": "3rem",
  "width": "3rem",
  "--tw-text-opacity": "1",
  "color": "rgb(209 213 219 / var(--tw-text-opacity))"
});